module.exports = __webpack_public_path__ + "img/quick-reviews.d68c44a3.png";